var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "text-center px-1", class: _vm.customClass },
    [
      _c("p", { staticClass: "lead py-1 mb-0" }, [
        _c("strong", { domProps: { innerHTML: _vm._s(_vm.title) } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }